export default "__VITE_ASSET__BSjY$yf9__"